import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

import { FaMapMarkerAlt } from 'react-icons/fa';
import logo from '../asserts/img/MP_logo.webp';
import './HomeDashboard.css';
import StatCard from './Home/StatCard';
import ExpertCallingCard from './Home/ExpertCallingCard';
import ContactCard from './Home/ContactCard';


const getRecentItems = (items, limit = 4) => {
  if (!items.length) return [];
  return [...items]
    .sort((a, b) => {
      const dateA = a.createdAt ? new Date(a.createdAt) : new Date(0);
      const dateB = b.createdAt ? new Date(b.createdAt) : new Date(0);
      return dateB - dateA || (b.id || 0) - (a.id || 0);
    })
    .slice(0, limit);
};

function Home() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState({
    expertData: [],
    contactData: [],
  });

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
      const headers = { headers: { Authorization: `Bearer ${token}` } };

      const [expertRes, contactRes] = await Promise.allSettled([
        getRequest('expertCalling', headers),
        getRequest('contactus', headers),
      ]);

      const safeData = (result) => result.status === 'fulfilled' ? result.value?.data?.data || [] : [];

      const expertData = safeData(expertRes);
      const contactData = safeData(contactRes);

      setDashboardData({
        expertData,
        contactData,
      });
    } catch (error) {
      console.error('Dashboard error:', error);
      toast.error('Failed to load dashboard');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="dash-loading">
        <div className="dash-loading__spinner" />
        <p>Loading Dashboard...</p>
      </div>
    );
  }

  const {
    expertData,
    contactData,
  } = dashboardData;

  const recentExpertCalls = getRecentItems(expertData, 4);
  const recentContactUs = getRecentItems(contactData, 4);

  return (
    <div className="dash-root">
      <div className="dash-banner">
        <div className="dash-banner__crest">
          <img src={logo} alt="Hospital Logo" style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '18px' }} />
        </div>
        <div className="dash-banner__text">
          {/* <span className="dash-banner__tag">Government of Madhya Pradesh</span> */}
          <h1>Govt. Seth Govind Das (Victoria) District Hospital</h1>
          <p><FaMapMarkerAlt /> Jabalpur, Madhya Pradesh &mdash; Admin Dashboard</p>
        </div>
      </div>

      <div className="stats-grid">
        <StatCard 
          label="Total Contact" 
          value={contactData.length} 
          type="info" 
          change="+18%" 
          subtext="Contact form submissions" 
          onClick={() => navigate('/contactus')}
        />
        <StatCard 
          label="Total Enquiry" 
          value={expertData.length} 
          type="warning" 
          subtext="Expert calling enquiries" 
          onClick={() => navigate('/expertcalling')}
        />
      </div>

      <div className="main-grid">
        <div className="charts-col">
          <div className="activity-card">
            <div className="activity-card__header">
              <h3>Expert Enquiries</h3>
              <button className="btn-secondary" onClick={() => navigate('/expertcalling')}>View All</button>
            </div>
            <div className="activity-list" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px'}}>
              {recentExpertCalls.map((e, i) => <ExpertCallingCard key={i} expert={e} />)}
              {recentExpertCalls.length === 0 && <p className="text-muted small">No expert calls.</p>}
            </div>
          </div>
        </div>

        <div className="sidebar-col">
          <div className="activity-card">
            <div className="activity-card__header">
              <h3>Latest Enquiries</h3>
              <button className="btn-secondary" onClick={() => navigate('/contactus')}>View All</button>
            </div>
            <div className="activity-list">
              {recentContactUs.map((c, i) => <ContactCard key={i} contact={c} />)}
              {recentContactUs.length === 0 && <p className="text-muted small">No enquiries found.</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
